import React from "react";
import "./Hero.scss";
import heroImage from "../../images/hero.png";

const Hero = () => {
  return (
    <section className="heroDreams" id="inicio">
      <div className="heroDreams__background">
        <img src={heroImage} alt="Quinceañera celebrando sus XV años" />
      </div>

      <div className="heroDreams__overlay"></div>
      <div className="heroDreams__glow heroDreams__glow--one"></div>
      <div className="heroDreams__glow heroDreams__glow--two"></div>

      <div className="container">
        <div className="heroDreams__content">
          <span className="heroDreams__tag">
            Donde los sueños de XV años comienzan a hacerse realidad
          </span>

          <h1>
            Todo lo que necesitas para tus <span>XV años</span>… en un solo
            lugar
          </h1>

          <p>
            Encuentra vestidos, salones, fotografía, maquillaje y más para
            <strong> hacer realidad la fiesta de tus sueños</strong> con una
            experiencia visual, elegante y fácil de explorar.
          </p>

          <div className="heroDreams__buttons">
            <a
              href="#categorias"
              className="heroDreams__btn heroDreams__btn--primary"
            >
              Explorar proveedores
            </a>

            <a
              href="#como-funciona"
              className="heroDreams__btn heroDreams__btn--secondary"
            >
              Comenzar a planear
            </a>
          </div>

          <div className="heroDreams__highlights">
            <div className="heroDreams__highlight">
              <strong>+10</strong>
              <span>Categorías clave</span>
            </div>

            <div className="heroDreams__highlight">
              <strong>Todo en uno</strong>
              <span>Más fácil para planear</span>
            </div>

            <div className="heroDreams__highlight">
              <strong>Inspiración real</strong>
              <span>Ideas para tu gran día</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;